// Standard library imports
import React, { useContext, useEffect, useState } from 'react';

// External library imports
import moment from 'moment-timezone';
import { get as LodashGet } from 'lodash';
import { UilCheck, UilTimes, UilQuestionCircle, UilExclamationTriangle } from '@iconscout/react-unicons';
import _ from 'lodash';
// Internal module imports
import classes from '../Economics.module.css';
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { CamelCaseToTextCase, Capitalize } from '../../../utils/stringHelper';
import { DownloadAsExcel } from '../../../utils/downloadAsExcel';
import { AuthContext } from '../../../context/AuthContext';
import ModalComponent from '../../../components/ModalComponent/ModalComponent';
import DownloadButton from '../../../components/Buttons/DownloadButton';
import DateRangePicker from '../../../components/Inputs/DateRangePicker/DateRangePicker';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import { DropdownComponent } from '../../../components/Inputs/Input';
import BiddingInfoContent from '../ModalComponent/Info';
import { UilInfoCircle } from '@iconscout/react-unicons';
import AlertModal from '../../../components/AlertModal/AlertModal';
import { LicenseTypeService } from '../../../services/Bidding/CommonServices/LicenseType';
import { InstanceService } from '../../../services/Bidding/CommonServices/InstanceService';
import { EconomicsService } from '../../../services/Bidding/EconomicsService';
import { momentTimeFormater } from '../../../utils/dateHelper';
import { toDkFormatterNoDecimalPlace } from '../../../utils/currencyHelper';
import { useLoader } from '../../../hooks/use-loader.hook';

const LIMIT = 15;

const getAreaOption = (customerArea = []) => {
    const temp = [{ label: 'All', value: 'all' }];

    customerArea.map((el) => {
        temp.push({ label: el, value: el });
    });

    return temp;
};

const Details = ({ updateQueryParams, queryParamsData = {} }) => {
    const date = new Date();
    const { state } = useContext(AuthContext);
    const customerId = LodashGet(state, ['user', 'customerId', 'id']);
    const cutomerName = LodashGet(state, 'user.customerId.name') || '';
    const [startLoader, stopLoader] = useLoader();
    const [dateRange, setDateRange] = useState({
        startDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.startDate) : new Date(date.getFullYear(), date.getMonth(), 1),
        endDate: queryParamsData.dateRange ? new Date(queryParamsData.dateRange.endDate) : new Date(date.getFullYear(), date.getMonth() + 1, 0),
    });
    const [tableData, setTableData] = useState([]);
    const [totalRevenue, setTotalRevenue] = useState({
        customer: 0,
        enablers: 0,
        sc: 0,
        partner: 0,

        customerEnergy: 0,
        enablersEnergy: 0,
        scEnergy: 0,
        partnerEnergy: 0,
        customerEnergyBeforeDhCost: 0,
    });
    const [hourlyModal, setHourlyModal] = useState({
        status: false,
        data: {},
    });
    const [skip, setSkip] = useState(0);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);

    const defaultValue = { label: 'All', value: 'all' };
    const [licenseTypes, setLicenseTypes] = useState([defaultValue]);
    const [licenseType, setLicenseType] = useState(defaultValue);
    const [instances, setInstances] = useState([defaultValue]);
    const [instance, setInstance] = useState(defaultValue);
    const [alertModal, setAlertModal] = useState(false);
    const [areaOptions, setAreaOption] = useState(getAreaOption(LodashGet(state, ['user', 'customerId', 'areas'], [])));
    const [selectedArea, setSelectedArea] = useState(defaultValue);

    useEffect(() => {
        if (instance) fetchTableData();
    }, [skip, instance, selectedArea.value]);

    useEffect(() => {
        fetchLicenseTypes();
    }, []);

    useEffect(() => {
        fetchInstance();
    }, [licenseType]);

    const fetchInstance = () => {
        if (licenseType.value !== 'all') {
            const params = { licenseId: licenseType.value, customerId: customerId };
            InstanceService.GetInstances(params, startLoader, handleInstanceSuccess, handleError, stopLoader);
        } else {
            setInstances([defaultValue]);
            setInstance(defaultValue);
        }
    };

    const fetchLicenseTypes = () => {
        LicenseTypeService.GetLicenseForCustomer(customerId, startLoader, handleLicenseTypesSuccess, handleError, stopLoader);
    };

    const handleInstanceSuccess = ({ data }) => {
        const processedData = [defaultValue];

        data?.data.forEach((type) => {
            processedData.push({ label: type.name, value: type._id });
        });
        setInstances(processedData);
        setInstance(defaultValue);
    };

    const handleLicenseTypesSuccess = ({ data }) => {
        const processedData = [defaultValue];

        data?.data.forEach((type) => {
            processedData.push({ label: CamelCaseToTextCase(type.name), value: type._id });
        });
        setLicenseTypes(processedData);
    };

    const fetchTableData = (skipNone = false, paginatedData = true, handler = null) => {
        const successHandler = handler ? handler : handleEconomicDataSuccess;
        const params = {
            startDate: moment(dateRange.startDate).format('YYYY-MM-DD'),
            endDate: moment(dateRange.endDate).format('YYYY-MM-DD'),
            licenseId: licenseType.value,
            instanceId: instance.value,
            ...(paginatedData ? { limit: LIMIT, skip: skipNone ? 0 : skip } : {}),
            area: selectedArea.value,
        };
        EconomicsService.GetEconomics(params, startLoader, successHandler, handleError, stopLoader);
    };

    const getEnablerRevenue = (enablers = {}, enablersData = []) => {
        let totalRevenue = 0;
        let tooltip = [];
        enablersData.map((e) => {
            for (const key in enablers) {
                if (key == e._id) {
                    totalRevenue = totalRevenue + Number(enablers[key]);
                    tooltip.push(`${e.name} : ${enablers[key].toLocaleString('da-DK')}`);
                }
            }
        });

        return (
            <CustomTooltip
                content={tooltip.map((e) => (
                    <div>{e}</div>
                ))}
            >
                <div className={classes.LinkTitle}>{totalRevenue.toLocaleString('da-DK')}</div>
            </CustomTooltip>
        );
    };
    const getIcon = (status, result, won) => {
        if (status === 'inactive') {
            return (
                <CustomTooltip content={'Bid not placed'}>
                    <UilQuestionCircle size="1.2vw" style={{ color: 'var(--color-primary)' }} />
                </CustomTooltip>
            );
        } else if (status === 'active' && !result) {
            return (
                <CustomTooltip content={'Settlements not found'}>
                    <UilExclamationTriangle size="1.1vw" style={{ color: 'var(--color-primary)' }} />
                </CustomTooltip>
            );
        } else if (status === 'active' && result && won) {
            return (
                <CustomTooltip content={'Won'}>
                    <UilCheck size="1.2vw" style={{ color: 'green' }} />
                </CustomTooltip>
            );
        } else if (status === 'active' && result && !won) {
            return (
                <CustomTooltip content={'Lost'}>
                    <UilTimes size="1.2vw" style={{ color: 'red' }} />
                </CustomTooltip>
            );
        }
    };

    const handleNull = (value) => (value || value === 0 ? (!isNaN(value) ? toDkFormatterNoDecimalPlace(value) : value) : '--');

    const handleEconomicDataSuccess = ({ data }) => {
        const enablersData = _.get(data, ['data', 'enablersData']);
        const totalRevenue = _.get(data, ['data', 'data', 'totalRevenue'], []);
        const processedData = _.get(data, ['data', 'data', 'formatedData'], []).map((item) => {
            const isInactive = _.get(item, ['modalData', 'energyRequestBidStatus'], []).some((el) => el === 'inactive');
            return {
                ...item,
                productName: item.productName || '--',
                productType: item.productType || '--',
                date: momentTimeFormater(item.date).format('DD-MM-YYYY'),
                capacity: handleNull(item.capacity || 0),
                customer: item.isResultFetched ? handleNull(item.customerRevenue) : '--',
                enablersRevenue: item.isResultFetched ? getEnablerRevenue(item?.enablersRevenue, enablersData) : '--',
                sc: item.isResultFetched ? handleNull(item.scRevenue) : '--',
                partner: item.isResultFetched ? handleNull(item.partnerRevenue) : '--',

                customerEnergy: item.isResultFetched ? handleNull(item.customerEnergyRevenue) : '--',
                enablersEnergyRevenue: item.isResultFetched ? getEnablerRevenue(item?.enablersEnergyRevenue, enablersData) : '--',
                scEnergy: item.isResultFetched ? handleNull(item.scEnergyRevenue) : '--',
                partnerEnergy: item.isResultFetched ? handleNull(item.partnerEnergyRevenue) : '--',

                status: (
                    <div className={classes.StatusContainer}>
                        {Object.keys(item.status).map((key) => (
                            <div className={classes.StatusContainer}>
                                {key === 'capacity' ? 'CM' : key === 'energy' ? 'EAM' : Capitalize(key)}{' '}
                                {getIcon(_.get(item, ['status', key, 'status']), _.get(item, ['status', key, 'result']), _.get(item, ['status', key, 'won']))}
                            </div>
                        ))}
                    </div>
                ),
                ...(!item.isResultFetched ? { style: { background: '#E6E8FA', color: '#4C5AD9' } } : {}),

                ...((item.type?.includes('aFRR') || item.type?.includes('mFRR')) && isInactive ? { style: { background: '#fef6e5', color: '#faa500' } } : {}),

                ...(item?.modalData !== null
                    ? {
                          info: (
                              <CustomTooltip content={'Bidding Info'}>
                                  <div
                                      style={{ display: 'flex', justifyContent: 'center' }}
                                      onClick={() => {
                                          setHourlyModal({
                                              status: true,
                                              data: {
                                                  capacity: {
                                                      overall: item.modalData.capacity,
                                                      panicHours: item.modalData.panicHours,
                                                  },
                                                  price: {
                                                      overall: item.modalData.price,
                                                      regulationPrice: item.modalData.regulationPrice || [],
                                                      energyStatus: _.get(item, ['status', 'energy', 'status'], 'inactive'),
                                                      energyRequestBidStatus: item.modalData?.energyRequestBidStatus || [],
                                                  },
                                                  hourlyData:
                                                      _.get(item, ['modalData', 'bidStatus'], []).length || _.get(item, ['modalData', 'energyStatus'], []).length
                                                          ? {
                                                                bidStatus: item.modalData.bidStatus,
                                                                energyStatus: item.modalData?.energyStatus,
                                                            }
                                                          : setAlertModal('SETTLEMENTS'),
                                              },
                                          });
                                      }}
                                  >
                                      <div>
                                          <UilInfoCircle size={'1.2vw'} style={{ color: 'var(--color-primary)' }} />
                                      </div>
                                  </div>
                              </CustomTooltip>
                          ),
                      }
                    : { info: '--' }),
            };
        });
        setTableData(processedData);
        setTotalRevenue({
            customer: handleNull(Math.round(totalRevenue.customer || 0)),
            enablers: handleNull(Math.round(totalRevenue.enabler || 0)),
            sc: handleNull(Math.round(totalRevenue.sc || 0)),
            partner: handleNull(Math.round(totalRevenue.partner || 0)),

            scEnergy: handleNull(Math.round(totalRevenue.scEnergy || 0)),
            partnerEnergy: handleNull(Math.round(totalRevenue.partnerEnergy || 0)),
            customerEnergy: handleNull(Math.round(totalRevenue.customerEnergy || 0)),
            enablersEnergy: handleNull(Math.round(totalRevenue.enablersEnergy || 0)),
            customerEnergyBeforeDhCost: handleNull(Math.round(totalRevenue.customerEnergyBeforeDhCost || 0)),
        });
        setTotalCount(_.get(data, ['data', 'data', 'count'], 0));
    };

    const exportEnablerRevenue = (enablers) => {
        let totalRevenue = 0;
        for (const key in enablers) {
            totalRevenue = totalRevenue + Number(enablers[key]);
        }
        return totalRevenue;
    };

    const handleDownloadExcel = ({ data }) => {
        let processExcelData = _.get(data, ['data', 'data', 'formatedData'], []).map((item) => ({
            date: momentTimeFormater(item.date).format('DD.MM.YYYY'),
            instance: item.instance,
            capacity: item.capacity,
            customer: item.isResultFetched ? item.customerRevenue : '--',
            partner: item.isResultFetched ? item.partnerRevenue : '--',
            enabler: item.isResultFetched ? exportEnablerRevenue(item.enablersRevenue) : '--',
            sc: item.isResultFetched ? item.scRevenue : '--',

            customerEnergy: item.isResultFetched ? item.customerEnergyRevenue : '--',
            customerEnergyRevenueBeforeDhCost: item.isResultFetched ? item.customerEnergyRevenueBeforeDhCost : '--',
            partnerEnergy: item.isResultFetched ? item.partnerEnergyRevenue : '--',
            enablersEnergy: item.isResultFetched ? exportEnablerRevenue(item.enablersEnergyRevenue) : '--',
            scEnergy: item.isResultFetched ? item.scEnergyRevenue : '--',
            type: item.type,
        }));
        const totalRevenue = _.get(data, ['data', 'data', 'totalRevenue'], []);

        processExcelData.push({
            capacity: 'Total',
            customer: totalRevenue.customer,
            partner: totalRevenue.partner,
            enabler: totalRevenue.enabler,
            sc: totalRevenue.sc,

            customerEnergy: totalRevenue.customerEnergy,
            customerEnergyRevenueBeforeDhCost: totalRevenue.customerEnergyRevenueBeforeDhCost,
            partnerEnergy: totalRevenue.partnerEnergy,
            enablersEnergy: totalRevenue.enablersEnergy,
            scEnergy: totalRevenue.scEnergy,
            type: 'Euro',
        });
        processExcelData.length > 1 &&
            DownloadAsExcel(
                processExcelData,
                `Economics ${momentTimeFormater(dateRange.startDate).format('YYYY-MM-DD')}-${momentTimeFormater(dateRange.endDate).format('YYYY-MM-DD')}`,
                [
                    'Date',
                    'Instance',
                    'Capacity (MW)',
                    'Customer CM (€)',
                    'Partner CM (€)',
                    'Enablers CM (€)',
                    'SC CM (€)',
                    'Customer EAM (€)',
                    'Customer EAM (After Cost) (€)',
                    'Partner EAM (€)',
                    'Enablers EAM (€)',
                    'SC EAM (€)',
                    'Type',
                ]
            );
    };

    const handlePageChange = (pageno) => {
        setSkip(LIMIT * pageno);
        setPage(pageno);
    };

    const handleError = (error) => {
        console.log(error);
    };

    return (
        <>
            <div className={classes.Details}>
                <div className={classes.Header + ' ' + classes.FilterBar}>
                    <div style={{ gap: '0.51vw' }}>
                        <div className={classes.FieldControl2}>
                            <label htmlFor="license">License</label>
                            <DropdownComponent defaultValue={defaultValue} options={licenseTypes} onChange={setLicenseType} />
                        </div>
                        <div className={classes.FieldControl2}>
                            <label htmlFor="area">Area</label>
                            <DropdownComponent defaultValue={selectedArea} options={areaOptions} onChange={setSelectedArea} />
                        </div>
                        <div className={classes.FieldControl2}>
                            <label htmlFor="instance">Instance</label>
                            <DropdownComponent defaultValue={defaultValue} options={instances} onChange={setInstance} />
                        </div>
                    </div>

                    <div className={classes.DatePickers}>
                        <div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className={classes.DateLabels}>Start Date</div>
                                <div className={classes.DateLabels} style={{ marginRight: '2.604vw' }}>
                                    End Date
                                </div>
                            </div>
                            <DateRangePicker
                                startDate={dateRange.startDate}
                                endDate={dateRange.endDate}
                                onChange={(date) => {
                                    setDateRange({ startDate: new Date(date.startDate), endDate: new Date(date.endDate) });
                                    updateQueryParams('dateRange', JSON.stringify(date));
                                }}
                                disableFutureDate={false}
                            />
                        </div>
                        <div
                            className={classes.SubmitButton}
                            onClick={() => {
                                fetchTableData(true);
                                setPage(0);
                            }}
                        >
                            <button className="btn-primary" style={{ marginTop: '1.2vw' }}>
                                Submit
                            </button>
                        </div>
                        <div style={{ marginTop: '1.2vw' }}>
                            <DownloadButton size="medium" onClick={() => fetchTableData(false, false, handleDownloadExcel)} />
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.Details}>
                <div className={classes.FilterContainer}>
                    <div className={classes.DropdownContainer}>
                        <div className={classes.TableCount}>
                            Total Revenue CM ({cutomerName}):
                            <span>
                                <Typography size="14" content={totalRevenue.customer + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue CM (Partner):
                            <span>
                                <Typography size="14" content={totalRevenue.partner + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue CM (Enablers):
                            <span>
                                <Typography size="14" content={totalRevenue.enablers + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue CM (SC):
                            <span>
                                <Typography size="14" content={totalRevenue.sc + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Count :
                            <span>
                                <Typography size="14" content={totalCount || 0} />
                            </span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '0.5vw' }}>
                        <CustomTooltip content={'EAM bid is inactive for some hours'}>
                            <div className={classes.ColorInfo} />
                        </CustomTooltip>
                        <CustomTooltip content={'The results have not been published yet'}>
                            <div className={classes.ColorInfo} style={{ background: '#E6E8FA' }} />
                        </CustomTooltip>
                    </div>
                </div>
                <div className={classes.FilterContainer}>
                    <div className={classes.DropdownContainer}>
                        <div className={classes.TableCount}>
                            Total Revenue EAM ({cutomerName}):
                            <span>
                                <Typography size="14" content={totalRevenue.customerEnergy + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue EAM (Partner):
                            <span>
                                <Typography size="14" content={totalRevenue.partnerEnergy + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue EAM (Enablers):
                            <span>
                                <Typography size="14" content={totalRevenue.enablersEnergy + ' €'} />
                            </span>
                        </div>
                        <div className={classes.TableCount}>
                            Total Revenue EAM (SC):
                            <span>
                                <Typography size="14" content={totalRevenue.scEnergy + ' €'} />
                            </span>
                        </div>
                    </div>
                </div>
                <Table
                    head={[
                        'Date',
                        'Instance',
                        'Capacity (MW)',
                        'Customer CM (€)',
                        'Partner CM (€)',
                        'Enablers CM (€)',
                        'SC CM (€)',
                        'Customer EAM (€)',
                        'Partner EAM (€)',
                        'Enablers EAM (€)',
                        'SC EAM (€)',
                        'Type',
                        'Status',
                        'Info',
                    ]}
                    keys={[
                        'date',
                        'instance',
                        'capacity',
                        'customer',
                        'partner',
                        'enablersRevenue',
                        'sc',
                        'customerEnergy',
                        'partnerEnergy',
                        'enablersEnergyRevenue',
                        'scEnergy',
                        'type',
                        'status',
                        'info',
                    ]}
                    data={[...tableData]}
                    page={page}
                    Pagination={true}
                    limit={LIMIT}
                    handlePageChange={handlePageChange}
                    totalCount={totalCount}
                />
                <ModalComponent
                    isOpen={hourlyModal.status}
                    setOpen={() => {
                        setHourlyModal({ status: false, data: {} });
                    }}
                >
                    <BiddingInfoContent data={hourlyModal.data} setOpen={setHourlyModal} />
                </ModalComponent>
                <AlertModal title={alertModal} isOpen={alertModal} content={'No Data Found!'} setOpen={setAlertModal} />
            </div>
        </>
    );
};

export default Details;
